import { useMemo } from 'react';
import { canUpdate } from 'utils/permissions';
import { PermissionActionsRetriever } from 'src/definitions/custom-models';
import { EngagementJobProfile } from './jobProfiles.mutations';

interface Args {
  loading: boolean;
  editableResource?: EngagementJobProfile | null;
}

export const useDisabledJobProfileFields = (args: Args) => {
  const { loading, editableResource } = args;

  return useMemo(() => {
    const shouldFieldBeDisabled = (permissionRetriever: PermissionActionsRetriever): boolean =>
      loading || (Boolean(editableResource) && !canUpdate(permissionRetriever(editableResource?.permissions)));

    const jobCode = shouldFieldBeDisabled((permissions) => permissions?.JOB_PROFILE_CODE);
    const name = shouldFieldBeDisabled((permissions) => permissions?.JOB_PROFILE_NAME);
    const countries = shouldFieldBeDisabled((permissions) => permissions?.JOB_PROFILE_COUNTRY);
    const classifications = shouldFieldBeDisabled((permissions) => permissions?.JOB_PROFILE_CLASSIFICATIONS);
    const mappedExports = shouldFieldBeDisabled((permissions) => permissions?.JOB_PROFILE_MAPPED_EXPORT_JOB_PROFILE);
    const summary = shouldFieldBeDisabled((permissions) => permissions?.JOB_PROFILE_SUMMARY);
    const jobFamily = shouldFieldBeDisabled((permissions) => permissions?.JOB_PROFILE_JOB_FAMILY);

    return {
      jobCode,
      name,
      countries,
      classifications,
      mappedExports,
      summary,
      jobFamily
    };
  }, [loading, editableResource]);
};
